import { useState, useEffect } from "react";
import api from "../api/api";

export function useProfitProfiles() {
  const [profiles, setProfiles] = useState([]);

  useEffect(() => {
    api
      .get("/accounts/profit-profiles/")
      .then((res) => setProfiles(res.data))
      .catch((err) => console.error("Failed to fetch profit profiles:", err));
  }, []);

  const create = async (payload) => {
    const res = await api.post("/accounts/profit-profiles/", payload);
    setProfiles((prev) => [...prev, res.data]);
    return res.data;
  };

  return { profiles, create };
}
